import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./Resource/en/common.json";
import translationHI from "./Resource/hn/common.json";
import { I18nKeys } from "./types/i18.type";


//Creating object with the variables of imported translation files

const enTranslation: I18nKeys = translationEN as unknown as I18nKeys;
const hiTranslation: I18nKeys = translationHI as unknown as I18nKeys;
// Ensure the imported JSON files match the I18nKeys type
if (!enTranslation || !hiTranslation) {
  throw new Error("Translation files do not match the I18nKeys type.");
}
const resources: Resource | undefined = {
  EN: {
    translation: enTranslation
  },
  HN: {
    translation: hiTranslation
  },
};

//i18N Initialization

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en", //default language
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
